/**
 *  Simple wrapper to namespace localStorage
 *
 *  @author Guilherme Minsoni Jacomini <guilhermem.j@hotmail.com>
 *
 *  @see https://developer.mozilla.org/en-US/docs/Web/API/Storage
 */
export default class NamespacedStorage {
  constructor(namespace) {
    this.namespace = namespace;
  }

  // Utility methods
  getNamespacedKey(key = '') {
    return `${this.namespace}.${key}`;
  }

  getUnamespacedKey(namespacedKey = '') {
    return namespacedKey.replace(`${this.namespace}.`, '');
  }

  isNamespacedKey(key = '') {
    const regex = new RegExp(`^${this.namespace}\\.`);

    return regex.test(key);
  }

  forEach(callback = () => {}) {
    for (let i = 0; i < localStorage.length; i += 1) {
      const keyName = localStorage.key(i);

      if (this.isNamespacedKey(keyName)) {
        callback(
          localStorage.getItem(keyName),
          this.getUnamespacedKey(keyName),
        );
      }
    }
  }

  // Web Storage methods
  getItem(key = '') {
    return localStorage.getItem(this.getNamespacedKey(key));
  }

  setItem(key = '', value) {
    localStorage.setItem(this.getNamespacedKey(key), value);
  }

  removeItem(key = '') {
    localStorage.removeItem(this.getNamespacedKey(key));
  }

  clear() {
    this.forEach((_, key) => this.removeItem(key));
  }
}
